import React from 'react';
import styled from 'styled-components';

function ScrollToTop() {

    const move = ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

  return (
    <ScrollWrapper>
        <Scroll onClick={move} className='scroll' >Scroll to top</Scroll>
    </ScrollWrapper>
  );
}

const ScrollWrapper= styled.div`
    transform: rotateZ(-90deg);
`

const Scroll = styled.p`
    position: relative;
    cursor: pointer;
    color: var(--primary);
    transition: all 0.5s ease;
    padding: 2rem 0rem;

    &:hover{
        transform: translateX(40%);
    }

    
    &::before{
        content: "";
        width: 60px;
        height: 2px;
        background-color: var(--primary);
        position: absolute;
        top: 50%;
        right: -68px;
    }
    &::after{
        content: "";
        width: 20px;
        height: 2px;
        background-color: var(--primary);
        position: absolute;
        top: 50%;
        right: -68px;
        transition: all 0.5s ease;
    }
    //to make other element also change on hover we have made other elements in before and after
    //now on hover of scroll before and after hover can also be written separately.
    &:hover:after{
        transform: rotateZ(-45deg) translate(-3px, 6px);
    }

    @media only screen and (max-width: 500px){
        display: none;
    }
`

export default ScrollToTop;